import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  // opts: { resourceType, resourceId } for one resource, { resourceType } for every resource of a type, or { tag }
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/resourcetag', { params: opts })
        .then(({ data }) => {
          context.commit('FILTER', opts)
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  // the socket layer only forwards the record id, so refresh whatever filter is currently loaded
  created (context, opts) {
    if (context.state.filter) context.dispatch('list', context.state.filter).catch(() => {})
  },
  updated (context, opts) {
    if (context.state.filter) context.dispatch('list', context.state.filter).catch(() => {})
  },
  destroyed (context, opts) {
    if (context.state.filter) context.dispatch('list', context.state.filter).catch(() => {})
  },
  // ===========================List Edits===============================
  // opts: { tag, resourceType, resourceId }
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/resourcetag', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/resourcetag/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
